module.exports = ".inicio {\n  font-size: 9vw;\n  text-shadow: 2px 2px 8px; }\n\n.pie-label {\n  font-size: 17px !important; }\n\n.newClass {\n  font-size: 17px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/inicio/inicio.component.scss
// module id = ./src/app/inicio/inicio.component.scss
// module chunks = main